import React from 'react';
import { Section } from '@atlaskit/menu';
import { useHasToolSections } from '@atlassian/jira-software-connect-toolbar/src/controllers';
import { BoardConnectMenuItems } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/index.tsx';
import type { BoardMenuItemLocation } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/types';

type BoardConnectItemsProps = {
	projectKey: string;
	boardId: string;
};

export const BoardConnectItems = ({ projectKey, boardId }: BoardConnectItemsProps) => {
	const itemLocations: BoardMenuItemLocation[] = ['board-tools-1', 'view-actions-print'];

	const hasToolSections = useHasToolSections({
		boardId,
		projectKey,
		mode: 'plan',
		itemLocations,
	});

	return (
		hasToolSections && (
			<Section hasSeparator>
				<BoardConnectMenuItems
					boardId={boardId}
					projectKey={projectKey}
					location="board-tools-1"
					mode="plan"
				/>
				<BoardConnectMenuItems
					boardId={boardId}
					projectKey={projectKey}
					location="view-actions-print"
					mode="plan"
				/>
				<BoardConnectMenuItems boardId={boardId} projectKey={projectKey} mode="plan" />
			</Section>
		)
	);
};
